export enum PaymentMethod {
	PAYPAL = 'paypal',
	CASH = 'cash',
	CREDIT_CARD = 'credit_card',
	VISA = 'visa',
	MASTERCARD = 'mastercard',
	SEPA = 'sepa',
	BALANCE = 'balance',
	POS = 'pos',
	SOFORTBANKING = 'sofortbanking',
	GPAY = 'google_pay',
	APAY = 'apple_pay',
	CCV = 'ccv',
	ZERO_PAYMENT = 'zero_payment',
	WOLT = 'wolt',
	UBER_EATS = 'uber_eats',
	JET = 'jet',
}
